export { default } from './getLengthOfStay';